import type { ReactNode } from 'react';
import cx from 'clsx';
import type { ImageProps } from 'next/legacy/image';
import NextImage from 'next/legacy/image';

export default function Image(props: ImageProps) {
  // eslint-disable-next-line jsx-a11y/alt-text
  return <NextImage unoptimized {...props} />;
}

export const AutoImageWrapper = ({
  children,
  className,
  ...props
}: {
  children: ReactNode;
  className?: string;
} & React.HTMLProps<HTMLDivElement>) => {
  return (
    <div
      className={cx([
        'w-full',
        '[&>span]:!static',
        '[&>span>img]:!h-auto',
        '[&>span>img]:!relative',
        '[&>span>img]:!object-contain',
        className,
      ])}
      {...props}
    >
      {children}
    </div>
  );
};

const shoebillImageLoader: ImageProps['loader'] = ({ src, quality, width }) => {
  return `${src}?q=${quality || 75}&t=contain&w=${width}`;
};

export function ShoebillImage({
  width = 768,
  height = 768,
  ...props
}: ImageProps) {
  // eslint-disable-next-line jsx-a11y/alt-text
  return (
    <NextImage
      width={width}
      height={height}
      {...props}
      loader={shoebillImageLoader}
    />
  );
}

export function getResizeImage({
  src,
  width = 768,
  quality = 75,
}: {
  src: string;
  width?: number;
  quality?: number;
}) {
  return `${src}?q=${quality}&t=contain&w=${width}`;
}
